import {styled} from '@esgi/ui/theme';
import {Box} from '@esgi/ui/layout';

export const Divider = styled(Box, {
	height: '20px',
	borderRadius: '1px',
	borderRight: '1.5px solid $neutral80',
	margin: '0 16px',
});
